import { supabase, MEDIA_BUCKET } from "./supabase.js";

const state = {
  ads: [],
  listeners: new Set(),
  channel: null,
  connected: false,
};

function notify() {
  for (const cb of state.listeners) cb([...state.ads]);
}

export function subscribe(cb) {
  state.listeners.add(cb);
  cb([...state.ads]);
  return () => state.listeners.delete(cb);
}

export function isConnected() {
  return state.connected;
}

export function getAds() {
  return [...state.ads];
}

export async function loadAds() {
  const { data, error } = await supabase
    .from("ads")
    .select("*")
    .order("updated_at", { ascending: false });
  if (error) throw error;
  state.ads = data || [];
  notify();
}

export function subscribeRealtime(onConnect) {
  if (state.channel) return;
  state.channel = supabase
    .channel("ads-changes")
    .on(
      "postgres_changes",
      { event: "*", schema: "public", table: "ads" },
      (payload) => {
        const { eventType, new: newRow, old: oldRow } = payload;
        if (eventType === "INSERT") {
          state.ads = [newRow, ...state.ads.filter((a) => a.id !== newRow.id)];
        } else if (eventType === "UPDATE") {
          state.ads = state.ads.map((a) => (a.id === newRow.id ? newRow : a));
        } else if (eventType === "DELETE") {
          state.ads = state.ads.filter((a) => a.id !== oldRow.id);
        }
        notify();
      }
    )
    .subscribe((status) => {
      state.connected = status === "SUBSCRIBED";
      if (onConnect) onConnect(state.connected);
    });
}

export async function addAd(ad) {
  const { data, error } = await supabase
    .from("ads")
    .insert([ad])
    .select()
    .single();
  if (error) throw error;
  // Optimistic: real-time event de tabloya yazacak, ama yine de hemen state'e ekle
  state.ads = [data, ...state.ads.filter((a) => a.id !== data.id)];
  notify();
  return data;
}

export async function updateAd(id, patch) {
  const { data, error } = await supabase
    .from("ads")
    .update(patch)
    .eq("id", id)
    .select()
    .single();
  if (error) throw error;
  state.ads = state.ads.map((a) => (a.id === id ? data : a));
  notify();
  return data;
}

export async function deleteAd(id) {
  const ad = state.ads.find((a) => a.id === id);
  // Önce DB satırı, sonra medya — DB hata verirse medyaya dokunma
  const { error } = await supabase.from("ads").delete().eq("id", id);
  if (error) throw error;
  state.ads = state.ads.filter((a) => a.id !== id);
  notify();
  if (ad && ad.media_path) {
    await supabase.storage.from(MEDIA_BUCKET).remove([ad.media_path]).catch(() => {});
  }
}

export async function uploadMedia(file) {
  const ext = file.name.split(".").pop().toLowerCase();
  const safeStem = file.name
    .replace(/\.[^.]+$/, "")
    .replace(/[^a-zA-Z0-9._-]/g, "-")
    .slice(0, 60);
  const path = `${Date.now()}-${safeStem}.${ext}`;
  const { error } = await supabase.storage
    .from(MEDIA_BUCKET)
    .upload(path, file, { contentType: file.type, upsert: false });
  if (error) throw error;
  return path;
}

export function getMediaPublicUrl(path) {
  if (!path) return "";
  const { data } = supabase.storage.from(MEDIA_BUCKET).getPublicUrl(path);
  return data.publicUrl;
}

export async function downloadMedia(path) {
  const { data, error } = await supabase.storage.from(MEDIA_BUCKET).download(path);
  if (error) throw error;
  return data; // Blob
}
